"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.map.js");
var _log = require("@/utils/log");
var _vuedraggable = _interopRequireDefault(require("vuedraggable"));
var _user = require("@/api/user");
var _loop = require("@/api/loop");
var _lodash = _interopRequireDefault(require("lodash"));
var _cookie = require("@/utils/cookie");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import * as utils from '@/utils/auth'
// import { writeGaEvent } from '@/utils/ga'
var _default = exports.default = {
  name: 'LoopStaff',
  components: {
    draggable: _vuedraggable.default
  },
  props: {
    parentId: {
      type: String,
      default: ''
    },
    internalTitle: {
      type: String,
      default: ''
    },
    loadStaff: {
      type: String,
      default: ''
    },
    tenant: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loadingUsers: false,
      loadingRoles: false,
      keywordSearch: '',
      staffList: [],
      /* otr staff library */
      mangerList: [],
      contactList: [],
      clientPocList: [],
      oldClientPocList: []
    };
  },
  computed: {
    fullSelectedList: function () {
      return _lodash.default.unionWith(this.mangerList, this.contactList, this.clientPocList);
    },
    loading: function () {
      return this.loadingUsers || this.loadingRoles;
    }
  },
  watch: {
    fullSelectedList: {
      handler(newVal) {
        (0, _log.showDebugLog)('Child-module emit to parent new value', newVal);
        this.passBackToParent(newVal);
      },
      deep: true
    },
    tenant: {
      handler(newVal) {
        if (newVal) {
          this.getStaffList();
        }
      }
    }
  },
  async created() {
    console.info("loadStaff:" + this.loadStaff);
    await this.getStaffList();
    if (this.loadStaff === 'true') {
      this.getStaffbyRole();
    }
  },
  methods: {
    /* no code */
    getStaffbyRole() {
      this.loadingRoles = true;
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      (0, _loop.getLoopStaff)(token, this.parentId).then(response => {
        //alert(JSON.stringify(response.data));
        this.loadingRoles = false;
        this.mangerList = response.data.rows.filter(row => row.role === 'manager').map(s => {
          return {
            role: s.role,
            user: s.user.uuid,
            name: `${s.user.givenName} ${s.user.middleName} ${s.user.familyName}`,
            enrollmentQuota: s.enrollmentQuota
          };
        });
        this.contactList = response.data.rows.filter(row => row.role === 'contact').map(s => {
          return {
            role: s.role,
            user: s.user.uuid,
            name: `${s.user.givenName} ${s.user.middleName} ${s.user.familyName}`,
            enrollmentQuota: s.enrollmentQuota
          };
        });
        this.clientPocList = response.data.rows.filter(row => row.role === 'client-poc').map(s => {
          return {
            role: s.role,
            user: s.user.uuid,
            name: `${s.user.givenName} ${s.user.middleName} ${s.user.familyName}`,
            enrollmentQuota: s.enrollmentQuota
          };
        });
        this.oldClientPocList = _lodash.default.cloneDeep(this.clientPocList);
      }).catch(error => {
        this.loadingRoles = false;
        (0, _log.showDebugLog)('GetLoopStaff-api-error', error);
      });
    },
    getStaffList() {
      this.loadingUsers = true;
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      const query = {
        page: 1,
        limit: 100,
        role: 'otr-coach,otr-product-admin,otr-digital-producer,client-staff',
        sort: 'givenName',
        q: this.keywordSearch
      };
      (0, _user.getUserList)(token, query).then(response => {
        // this.list = response.data.items
        this.loadingUsers = false;
        let rows = response.data.rows;
        if (this.tenant) {
          rows = rows.filter(s => s.metadata && s.metadata.tenants && s.metadata.tenants.includes(this.tenant));
        }
        this.staffList = rows.map(s => {
          return {
            role: '',
            user: s.uuid,
            name: `${s.givenName} ${s.middleName} ${s.familyName}`,
            sysRole: s.role,
            enrollmentQuota: 0
          };
        });
      }).catch(error => {
        this.loadingUsers = false;
        (0, _log.showDebugLog)('GetUserList-api-error', error);
        // this.$message({ type: 'error', showClose: true, duration: 5000, message: error.response.data.message })
      });
    },
    isDproducer(sysRoleArray) {
      return _lodash.default.indexOf(sysRoleArray, 'otr-digital-producer') > -1;
    },
    cloneLibrary(e) {
      return {
        role: e.role,
        user: e.user,
        name: e.name,
        sysRole: e.sysRole,
        enrollmentQuota: 0
      };
    },
    updateLibrary: function (evt) {},
    updateManagerList(evt) {
      this.mangerList = _lodash.default.uniqBy(this.mangerList, 'user');
      (0, _log.showDebugLog)('Loop-dragdrop-manager ', evt);
      if (evt.added) {
        evt.added.element.role = 'manager';
      }
    },
    updateContactList(evt) {
      this.contactList = _lodash.default.uniqBy(this.contactList, 'user');
      (0, _log.showDebugLog)('Loop-dragdrop-contact', evt);
      if (evt.added) {
        evt.added.element.role = 'contact';
      }
    },
    updateClientPocList(evt) {
      this.clientPocList = _lodash.default.uniqBy(this.clientPocList, 'user');
      (0, _log.showDebugLog)('Loop-dragdrop-contact', evt);
      if (evt.added) {
        evt.added.element.role = 'client-poc';
      }
    },
    removeManager(idx, clist) {
      clist.splice(idx, 1);
    },
    removeContact(idx, alist) {
      alist.splice(idx, 1);
    },
    removeClientPoc(idx, clist) {
      clist.splice(idx, 1);
    },
    passBackToParent(staff) {
      if (staff) {
        this.$emit('updateParentStaff', staff);
      } else {
        this.$emit('updateParentStaff', []);
      }
    },
    sendEnrollmentToPOC() {
      // const haveClientPoc = this.oldClientPocList.filter(item => {
      //   let index = this.clientPocList.findIndex(v => {
      //     return item.user == v.user
      //   })
      //   return index !== -1
      // });
      // console.info(haveClientPoc.length)
      if (this.clientPocList.length > 0)
        // call api
        {
          const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
          (0, _loop.loopNotifyLoopClientPOC)(token, this.parentId, {
            role: "client-poc",
            action: "send-enrollment-form"
          }).then(response => {
            this.$message({
              type: 'success',
              message: 'The enrollment form is successfully sent to Client POC by email.'
            });
          }).catch(error => {
            (0, _log.showDebugLog)('loopNotifyLoopClientPOC-api-error', error);
            this.$message({
              type: 'error',
              showClose: true,
              duration: 5000,
              message: error.response.data.message
            });
          });
        } else {
        const msg = "No Client POC is configured for this Loop. Please add it.";
        (0, _log.displayPopupMessage)(msg, "error");
        return;
      }
    }
  }
};